import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Profile } from './models/Profile';
import { ProfileFormComponent } from './profile-form/profile-form.component';

@Component({
  selector: 'app-profile-management',
  templateUrl: './profile-management.component.html'
})
export class ProfileManagementComponent implements OnInit {
  dataLoading = false;
  details!: Profile;

  constructor(
    public dialog: MatDialog,
    private service: AuthenticationService,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.getProfile();
  }


  getProfile() {
    this.dataLoading = true;
    this.service.GetUserDetails().subscribe((data) => {
      this.dataLoading = false;
      this.details = data;

      let currentUser = this.service.currentUserValue;
      if (currentUser) {
        currentUser.profilePic = this.details.profilePicture;
        this.service.currentUserSubject.next(currentUser);
      }
    },
      (error: any) => {
        this.dataLoading = false;
        // this.service.logout();
      });
  }

  openForm() {
    if (this.details.canEdit) {
      const dialogRef = this.dialog.open(ProfileFormComponent, {
        width: '560px',
        data: { details: this.details }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.getProfile();
        }
      });
    }
  }
}
